import { render } from "./AuditTrail.vue?vue&type=template&id=2faf7475&scoped=true"
import script from "./AuditTrail.vue?vue&type=script&lang=js"
export * from "./AuditTrail.vue?vue&type=script&lang=js"

import "./AuditTrail.vue?vue&type=style&index=0&id=2faf7475&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faf7475"]])

export default __exports__